#
# Enums
#

enum LivesAssured {
  LIVES_ASSURED_FIRST
  LIVES_ASSURED_SECOND
  LIVES_ASSURED_BOTH
}

enum EmploymentStatusProtection {
  EMPLOYMENT_EMPLOYED
  EMPLOYMENT_FIXED_TERM_CONTRACTOR
  EMPLOYMENT_FIXED_TERM_CONTRACTOR_PAYE
  EMPLOYMENT_HOMEMAKER
  EMPLOYMENT_RETIRED
  EMPLOYMENT_SELF_EMPLOYED
}

enum DeferredPeriod {
  DEFERRED_PERIOD_ZERO
  DEFERRED_PERIOD_ONE_WEEK
  DEFERRED_PERIOD_TWO_WEEKS
  DEFERRED_PERIOD_ONE_MONTH
  DEFERRED_PERIOD_TWO_MONTHS
  DEFERRED_PERIOD_THREE_MONTHS
  DEFERRED_PERIOD_SIX_MONTHS
  DEFERRED_PERIOD_ONE_YEAR
  DEFERRED_PERIOD_TWO_YEARS
}

enum BenefitBasis {
  BENEFIT_BASIS_MONTHLY
  BENEFIT_BASIS_MAXIMUM
}

enum WaiverOfPremium {
  INVALID_WAIVER_OF_PREMIUM
  WAIVER_OF_PREMIUM_FIRST
  WAIVER_OF_PREMIUM_SECOND
  WAIVER_OF_PREMIUM_BOTH
}

enum BenefitQuoteQuoteStatus {
  INVALID
  QUOTED
  FAILED
}

#
# Types
#

type ProductEstimateResponse {
  product_price: String!
  product_price_frequency: String!
  exception: Exception
}

type Benefit {
  product_type: SolutionProductType!
  payout_type: PayoutType
  amount: String!
  errors: [String!]
}

type SplitCoverBenefit {
  id: ID!
  product_type: ProtectionProductType
  cover_amount: String
  cover_amount_life: String
  cover_amount_cic: String
  cover_amount_life_or_earlier_cic: String
  include_total_permanent_disability: Boolean
  premium_type: PremiumType
  waiver_of_premium: WaiverOfPremium
  deferred_period: DeferredPeriod
  indexation_type: IndexationType
  indexation_percentage: Int
  benefit_basis: BenefitBasis
  include_low_start: Boolean
  cover_amount_depreciation_rate: Int
  term_years: Int
  term_age: Int
  lives_assured: LivesAssured
}

type SplitCoverClientDetails {
  employment_status: EmploymentStatusProtection
  occupation_code: String
  income: String
  date_of_birth: String
  is_smoker: Boolean
  first_name: String
  last_name: String
  gender: Gender
  title: Title
}

type SplitCoverBenefits {
  client_details: [SplitCoverClientDetails!]
  benefits: [SplitCoverBenefit!]
}

type SplitCoverQuote {
  id: ID
  status: BenefitQuoteQuoteStatus
  errors: [String]
  premium: String
}

type SplitCoverQuotes {
  quotes: [SplitCoverQuote!]
}

#
# Inputs
#

input ProductEstimateInput {
  clients: [ProductEstimateClientInput]!
  product_benefits: ProductBenefitInput!
}

input ProductEstimateClientInput {
  client_id: String!
  details: ProductEstimateClientDetailsInput!
}

input ProductEstimateClientDetailsInput {
  date_of_birth: String!
  gender: Gender!
  employment_status: EmploymentStatusProtection
  first_name: String!
  income: String!
  is_smoker: Boolean!
  last_name: String!
  occupation_code: String
  title: Title!
  client_height: Int
  client_weight: Int
}

input ClientBenefitRequirementInput {
  client_id: String!
  details: ClientDetailsInput!
  benefit_requirements: BenefitRequirementInput!
}

input ClientDetailsInput {
  employment_status: EmploymentStatusProtection
  occupationCode: String
  income: String!
  date_of_birth: String!
  is_smoker: Boolean
}

input BenefitRequirementInput {
  term_years: Int
  term_age: Int
  include_total_permanent_disability: Boolean
  cover_amount: String
  premium_type: PremiumType
  mortgage_interest_rate: String
  include_waiver_of_premium: Boolean
  deferred_period: DeferredPeriod
  indexation: IndexationType
  benefit_basis: BenefitBasis
  include_low_start: Boolean
  cover_amount_depreciation_rate: String
}

input SplitCoverBenefitInput {
  id: ID
  product_type: ProtectionProductType
  cover_amount: String
  cover_amount_life: String
  cover_amount_cic: String
  cover_amount_life_or_earlier_cic: String
  include_total_permanent_disability: Boolean
  premium_type: PremiumType
  waiver_of_premium: WaiverOfPremium
  deferred_period: DeferredPeriod
  indexation_type: IndexationType
  indexation_percentage: Int
  benefit_basis: BenefitBasis
  include_low_start: Boolean
  cover_amount_depreciation_rate: Int
  term_years: Int
  term_age: Int
  lives_assured: LivesAssured
}

input SplitCoverClientDetailsInput {
  employment_status: EmploymentStatusProtection
  occupation_code: String
  income: String
  date_of_birth: String
  is_smoker: Boolean
  first_name: String
  last_name: String
  gender: Gender
  title: Title
}

input SplitCoverBenefitsInput {
  client_details: [SplitCoverClientDetailsInput!]
  benefits: [SplitCoverBenefitInput!]
}
